import ArticleLimiter from './ArticleLimiter.vue'
import ArticleLimitModal from './modals/ArticleLimitModal.vue'
import DownloadLimiter from './DownloadLimiter.vue'
import ArticleFeed from './ArticleFeed.vue'
import AudioPlayer from './AudioPlayer.vue'

const articleComponents = [ArticleLimiter, DownloadLimiter, ArticleLimitModal, ArticleFeed, AudioPlayer ]

export default articleComponents
